import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTag = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 39.97 39.97",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.44 11.82a3.38 3.38 0 0 1-3.38-3.38 3.38 3.38 0 0 1 3.38-3.38 3.38 3.38 0 0 1 3.38 3.38 3.38 3.38 0 0 1-3.38 3.38zM39 21.24L20.13 2.4A8.18 8.18 0 0 0 17.44.7a8.15 8.15 0 0 0-3.09-.7h-11A3.24 3.24 0 0 0 1 1a3.24 3.24 0 0 0-1 2.38v11a8.14 8.14 0 0 0 .7 3.09 7.85 7.85 0 0 0 1.7 2.63L21.26 39a3.23 3.23 0 0 0 2.37 1A3.38 3.38 0 0 0 26 39l13-13a3.23 3.23 0 0 0 1-2.37 3.38 3.38 0 0 0-1-2.4z",
			className: "cls-1",
			"data-name": "Layer 1"
		})
	})
});
export default SvgIconTag;
